import { render, staticRenderFns } from "./Philosophy.vue?vue&type=template&id=8be1928a&scoped=true"
import script from "./Philosophy.vue?vue&type=script&lang=js"
export * from "./Philosophy.vue?vue&type=script&lang=js"
import style0 from "./Philosophy.vue?vue&type=style&index=0&id=8be1928a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be1928a",
  null
  
)

export default component.exports